/**
 * 메모(스티키 노트) 관련 스타일 컴포넌트
 */
import styled from 'styled-components';

export const InlineStickyNote = styled.div<{ $color: 'green' | 'yellow' | 'blue'; $translateX?: number; $isVisible?: boolean }>`
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 4px;
  background-color: ${props => {
    if (props.$color === 'green') return '#EBFFCF';
    if (props.$color === 'yellow') return '#FEFFCF';
    if (props.$color === 'blue') return '#E3F2FF';
    return '#FEFFCF';
  }};
  border: 2px solid ${props => {
    if (props.$color === 'green') return '#C1DC9B';
    if (props.$color === 'yellow') return '#E3E4A7';
    if (props.$color === 'blue') return '#C2D2E1';
    return '#E3E4A7';
  }};
  border-radius: 8px;
  padding: ${props => props.theme.spacing.md};
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  min-width: 300px;
  max-width: 400px;
  z-index: 10;
  pointer-events: auto;
  cursor: pointer;
  box-sizing: border-box;
  transform: ${props => props.$translateX !== undefined ? `translateX(${props.$translateX}px)` : 'translateX(0)'};
  transition: transform 0.2s ease, opacity 0.2s ease, visibility 0.2s ease;
  max-width: min(400px, 100%);
  opacity: ${props => props.$isVisible !== false ? 1 : 0};
  visibility: ${props => props.$isVisible !== false ? 'visible' : 'hidden'};
  
  @media (max-width: 768px) {
    min-width: unset;
    max-width: min(400px, calc(100% - 20px));
    width: auto;
    min-width: 200px;
  }
  
  @media (max-width: 480px) {
    max-width: min(350px, calc(100% - 20px));
    width: auto;
    min-width: 150px;
    padding: ${props => props.theme.spacing.sm};
  }
`;

export const InlineTitleAndColorRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${props => props.theme.spacing.sm};
`;

export const InlineColorSelector = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.xs};
  justify-content: flex-end;
`;

export const InlineColorButton = styled.div<{ $color: 'green' | 'yellow' | 'blue' }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid ${props => {
    if (props.$color === 'green') return '#C1DC9B';
    if (props.$color === 'yellow') return '#E3E4A7';
    if (props.$color === 'blue') return '#C2D2E1';
    return '#E3E4A7';
  }};
  background-color: ${props => {
    if (props.$color === 'green') return '#EBFFCF';
    if (props.$color === 'yellow') return '#FEFFCF';
    if (props.$color === 'blue') return '#E3F2FF';
    return '#FEFFCF';
  }};
`;

export const InlineStickyNoteTitle = styled.div`
  font-size: ${props => props.theme.fontSize.base};
  font-weight: ${props => props.theme.fontWeight.medium};
  color: ${props => props.theme.colors.gray[900]};
  flex: 1;
  margin-right: ${props => props.theme.spacing.sm};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const InlineStickyNoteDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #E3E4A7;
  margin: ${props => props.theme.spacing.xs} 0;
`;

export const InlineStickyNoteContent = styled.div`
  font-size: ${props => props.theme.fontSize.sm};
  color: ${props => props.theme.colors.gray[900]};
  line-height: 1.5;
  white-space: pre-wrap;
  max-height: 150px;
  overflow-y: auto;
`;

